import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { setHapticFeedbackSetting } from '@core/Areas/Settings/Store'
import { isHapticFeedbackSettingEnabled } from '@core/Areas/Settings/Store/selectors'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'

export const isHapticsSupported = isReactNativeApp || Boolean(window.navigator.vibrate)

export const HapticFeedbackSetting: React.FC = () => {
  const dispatch = useDispatch()
  const isHapticFeedbackEnabled = useSelector(isHapticFeedbackSettingEnabled)

  return (
    <SettingItemWithCheckbox
      isEnabled={isHapticFeedbackEnabled}
      label='Allow Haptic Feedback'
      description='Enables a subtle vibration to trigger on important events, such as successful bet placement.'
      onToggle={() => {
        dispatch(setHapticFeedbackSetting(!isHapticFeedbackEnabled))
      }}
    />
  )
}
